import { createContext, useState } from 'react';

export const ModalContext = createContext();

export const ModalContextsProvider = ({ children }) => {
  const [customerWalletDrawer, setCustomerWalletDrawer] = useState(false);
  const [addTeamMemberModal, setAddTeamMemberModal] = useState(false);
  const [createMerchantModal, setCreateMerchantModal] = useState(false);
  const [generateKeyModal, setGenerateKeyModal] = useState(false);
  const [mobileSidebar, setMobileSidebar] = useState(false);
  const [addAccountModal, setAddAccountModal] = useState(false);
  const [registerAccountModal, setRegisterAccountModal] = useState(false);
  const [withdrawalModal, setWithdrawalModal] = useState(false);

  return (
    <ModalContext.Provider
      value={{
        customerWalletDrawer,
        setCustomerWalletDrawer,
        addTeamMemberModal,
        setAddTeamMemberModal,
        createMerchantModal,
        setCreateMerchantModal,
        generateKeyModal,
        setGenerateKeyModal,
        mobileSidebar,
        setMobileSidebar,
        addAccountModal,
        setAddAccountModal,
        setRegisterAccountModal,
        registerAccountModal,
        withdrawalModal,
        setWithdrawalModal,
      }}>
      {children}
    </ModalContext.Provider>
  );
};
